// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import { Injectable } from '@angular/core';
import { pmGetLastDataSourceRefreshInformations } from '../../../api/remote-api/.patternmatch.generated/fn/pattern-match/pm-get-last-data-source-refresh-informations';
import { MapApiService } from '../../shared/services/map-api.service';

@Injectable({ providedIn: 'root' })
export class LastdataSourceRefreshInformationsService {
  public lastDataSourceRefreshInformations = this.mapApiService.mapEndpoint(
    pmGetLastDataSourceRefreshInformations,
    {
      customCacheKey: ({
        modality,
        systemSerialNumber,
        systemMaterialNumber,
      }) => `${modality}-${systemMaterialNumber}-${systemSerialNumber}`,
    }
  );

  constructor(private mapApiService: MapApiService) {}
}
